export const VERY_HIGH_CONFIDENCE_SCORE = 0.1;

export const HIGH_CONFIDENCE_SCORE = 0.01;

export const MEDIUM_CONFIDENCE_SCORE = 0.001;
